export default {
  Andpenalties: 'Liquidated Damages and Penalties.',
  DeliveryFailed: 'Delivery failed, refunds are borne by Party A',
  abandonedRequests: '弃单请求',
  abandonedorder: '弃单',
  accesshelpcenter: '访问我们的帮助中心',
  accessoriesLessDelivery:
    'Lack of accessories, less delivery, refunds are borne by Party A',
  accesstoken: '访问令牌',
  accessurlexample: '示例：your-store.com',
  accessurlprefix: 'URL不能包含以下值：www., https://, http://, /',
  actions: '操作',
  activate: '激活',
  activateStore: '如果您要使用我们的在线商店，请激活它以释放所有DNS记录。',
  active: '启用',
  active2: '行动',
  actuallyPrice: '实付金额',
  addDomainTips1: '链接一个已经属于你的域名。',
  addDomainTips2: '你也可以链接一个子域名。例如：',
  addDomainTips3: '不要使用 ',
  addDomainTips4: '注意！为了让您的域名正常工作，',
  addDomainTips5: '您需要购买并使用托管服务进行设置',
  addDomainTips6: '或其他服务。',
  addDomainTips7: '如果有任何问题，请咨询我们的',
  addPopup: '新增优惠券',
  addastore: '添加商店',
  addstore: '添加商店',
  afterEachSuccessful:
    '乙方每笔交易成功后，甲方将提取乙方成功交易金额的5%，并将循环保证金存入甲方账户，同时转账给乙方。甲方账户中每笔交易的循环保证金将保留45天，45天后将金额发放给乙方。',
  afterSales: '售后邮箱，客户发送售后问题至这个邮箱，售后团队会进行回复',
  afterVerification:
    'If the refund reason falls into the following five situations after verification, the refund will be borne by Party B',
  agreetoNY: '通过创建账户，您同意USAdrop的',
  alreadyhaveanaccount: '已经有一个账户？',
  and: '和',
  apikey: 'API密钥',
  apisecretkey: 'API秘密密钥',
  ativo: '活跃',
  backgroundColor: '背景色',
  basicinformation: '基本信息',
  blacklisted:
    'If the customer is blacklisted, the refund shall be cancelled and borne by Party B',
  blacklistedCustomer: 'Blacklisted customer, cancel refund',
  borneByParty: `Due to Party B's failure to pay in time, the customer requests to cancel the order, and the refund shall be borne by Party B`,
  borneParty:
    'If the product is not satisfactory (does not like it), the refund shall be borne by Party A',
  buttonText: '按钮文案',
  cancel: '取消',
  cancellationAnd:
    'If the order is not shipped and the customer requests cancellation and refund, the refund shall be borne by Party B',
  cardPaymentsAnswer: '一旦客户向我们的账户付款，第二天就会转入您的钱包。',
  cardPaymentsTitile: '客户下单后需要多长时间才能将款项转入我的帐户',
  carddesc: '卡片，票据，银行存款和PIX',
  changeAddress:
    'For requests to change the address after the goods have been shipped, the refund shall be borne by Party B',
  classic: '经典',
  collaboratorRequestCode:
    '店铺合作员权限和代码（我们的电子邮件是 _email_，请处理权限）',
  collapsemenu: '折叠菜单',
  confirm: '确认',
  confirmedAndThe:
    'If the order is to be confirmed and the customer does not reply for more than 2 days, the refund shall be borne by Party B',
  confirmpassword: '确认密码',
  contentTerms: 'Content Terms',
  convertedOrderPaid: '已转订单(已支付)',
  convertedOrderUnpaid: '已转订单\n(未支付)',
  copy: '复制',
  correspondingPenalties: `Party B must comply with laws and regulations as well as Party A and the card organization's risk management requirements for illegal transactions. If Party B violates any of these regulations, Party B will be subject to corresponding penalties and fines.`,
  countdownImage: '倒计时图',
  countdownTimer: '倒计时间',
  country: '国家',
  coupon: '优惠券',
  couponCode: '优惠码（选填）',
  creatanaccount: '创建一个账户',
  createTime: '创建时间',
  createaccounttitle: '在我们的基础计划中创建您的免费账户，无需月费。',
  createfreeaccount: '创建免费账户',
  createpassword: '创建密码',
  currencyConversionAnswer: '根据支付提供商提供的官方汇率进行转换',
  currencyConversionTitle: '货币转化问题',
  currentStoreName: '当前店铺：',
  customerBuysMore:
    'If the customer buys more and wants to cancel and refund, the refund shall be borne by Party B',
  date: '日期',
  days: '天',
  defaultDomainTips:
    '这是USAdrop提供的免费域名。它总是有效的。但我们建议建立自己的。',
  delete: '删除',
  deleteSelected: '删除选定',
  deleteSuccess: '删除成功！',
  deletedSuccessfully: '删除成功',
  deliveryTime:
    'The customer receives the goods, the delivery time is too long, exceeding the store time limit, refunds are borne by Party A',
  disable: '禁用',
  disabledSuccessfully: '禁用成功',
  discount: '折扣',
  discountAmount: '折扣金额',
  discountPercent: '折扣百分比',
  discountRate: '折扣比例',
  dnsNormal: 'DNS记录配置正常',
  dnsNotConfigured: 'DNS记录未配置或未传播。',
  dnsRecordsTitle: '您的在线商店的DNS记录',
  domain: '域名',
  domainbtntext: '去设置',
  domaintitle: '在这里设置与您的Shopify商店相同的域名。',
  eachSuccessfulTransaction:
    '乙方每笔交易成功后，甲方将提取乙方成功交易金额的10%，并将循环保证金存入甲方账户，同时转账给乙方。甲方账户中每笔交易的循环保证金将保留45天，90天后将金额发放给乙方。',
  edit: '编辑',
  editstore: '编辑商店',
  email: '电子邮箱',
  emailContent: '邮件内容',
  emailReminders: '电子邮件提醒',
  emailRemindersDesc: '设置电子邮件提醒和订单折扣',
  emailTemplateConfig: '邮件模版配置',
  emailTemplateConfigDesc: '邮件自定义内容填写',
  emailTitle: '邮件主题',
  embedPaymentMethods: '通过邮件在不同时间催促客户完成付款，提高订单转化率',
  emptyCouponDesc:
    '配置优惠券后，将在完成支付后弹出优惠券领取弹窗，提示用户使用优惠券更优惠。',
  emptyCouponTitle: '配置您的优惠券',
  enable: '启用',
  enableCouponTips: '只能同时启用一张优惠券，请先禁用其他优惠券后再进行操作！',
  enabledSuccessfully: '启用成功',
  end: '结束',
  endDate: '结束日期',
  enter: '登录',
  entercorrectemail: '请输入正确的电子邮箱格式',
  enteremailandpassword: '输入您的电子邮箱和密码',
  example: '例子',
  faqs: '常见问题解答',
  firstPaymentChannel: '首次订单的支付方式',
  firsttimeaNY: '第一次访问USAdrop吗？',
  followInstructions: '请按照说明进行操作',
  followingPenalties:
    'In addition to the above-mentioned fines, those who violate the regulations seriously will face the following penalties:',
  forBrazil: '对于巴西：',
  forMexico: '墨西哥/智利/哥伦比亚/秘鲁：',
  forPaymentFailure:
    'For payment failure, the refund shall be borne by Party B',
  forShopify: '当您注册 Shopify 时，您的在线商店就会获得一个 myshopify.com URL',
  forgetpassword: '我忘记了密码',
  fullname: '全名',
  goodsNum: '个商品',
  gtm: 'Container ID',
  gtmRequired: 'Container ID is required',
  gtmDomain: '伺服器容器网址必填',
  gtmDomainRequired: '伺服器容器网址必填',
  googleid: '衡量 ID',
  googlekey: 'Measurement Protocol API 密钥',
  googleidRequired: '衡量 ID必填',
  googlekeyRequired: 'Measurement Protocol API 密钥必填',
  hasBeenSigned:
    'Logistics shows that it has been signed, but the customer has not received it, refunds are borne by Party A',
  hasquestions: '有问题吗？',
  headerImage: '头图',
  helpCenter: '帮助中心',
  helpaddress: 'bento.me/enchentesrs',
  hi: '您好',
  holding: '1、 控股公司',
  home: '首页',
  howtocontribute: '查看如何贡献于',
  howtoset: '如何设置',
  identifyyourself: '请身份验证',
  imitationBrand: 'Imitation/imitation brand',
  inActive: '未启用',
  inativo: '不活跃',
  info: '用户信息',
  installtitle: '在您的Shopify商店中安装USAdrop透明结账。',
  invitationNumber: '邀请码',
  invitationNumberError: '请填写您的邀请码以完成注册',
  isConfirmDelete: '是否确认删除？',
  kEmail: '邮件',
  kName: '姓名',
  learnMore: 'learn more.',
  lengthLimit: '长度应为3到8个字符',
  letteringPattern:
    'Product quality (size, color difference, damage, stains, thread ends, odor, wrinkles, fading, shrinkage, lettering, pattern, logo, accessories), refunds are borne by Party A',
  like: '喜欢',
  linkNewDomain: '链接新域名',
  liquidatedDamages: 'Liquidated Damages and Penalties',
  logaccount: '您已登录到：',
  loginsuccess: '登录成功！',
  logout: '登出',
  logoutSYS: '是否要登出系统？',
  lougoutsuccess: '登出成功！',
  markAsActive: '标记为活跃',
  markAsInactive: '标记为不活跃',
  min: '分钟',
  mydomain: '我的域名',
  mydomains: '我的域名',
  mydomainsdesc:
    '在这里管理您的域名。链接您的域名并将其配置为您商店和结账的虚拟地址。',
  name: '名称：',
  needhelp: 'Rio Grande do Sul 需要您的帮助。',
  newaffiliations: '新联盟',
  newpixel: '新像素',
  nextPage: '下一页',
  backToMessages: '返回消息列表',
  messageDetail: '消息详情',
  noNotifications: '暂无消息',
  notifications: '消息通知',
  refresh: '刷新',
  no: '否',
  noDomain: '没有域名',
  noStatus: '无状态',
  noUseDefaultDomain: '不要使用USAdrop默认支付域名！',
  noUseOrgin: '不要使用 http:// https:// 和 www',
  nocountriesavailable: '没有可用国家',
  nodatareadtitle: '阅读我们的完整文章',
  nodatastartsell: '当您开始销售时，您的订单将出现在这里。',
  nodatatip1: '通过企业的外观自定义您的商店！',
  nodatatip2: '提供多种支付方式。',
  nodatatip3: '为您的产品添加好的照片。',
  nodatatip4: '使您的产品描述具有吸引力并使用SEO技术。',
  nodatatip5: '投资于付费流量：社交网络和谷歌购物上的广告。',
  nodatatip6: '看看您的产品价格是否有吸引力。',
  nodatatip7: '有一个客户服务渠道来回答问题',
  nodatatips: '七个快速提示帮助您实现第一次销售：',
  nodatatitle: '还没有订单可以显示',
  nodeDescription: '节点描述',
  nodeName: '节点名称',
  operation: '操作',
  order: '订单',
  orderCancel: '已取消',
  orderClosed: '已关闭',
  orderConversion: '订单转化',
  orderConversionTipUnpaid: '通过再营销挽回，但仍未支付。',
  orderConversionTipUnconverted: '客户从未支付。',
  orderConversionTipPaid: '通过再营销挽回并已成功支付。',
  orderConversionTipPending: '客户已发起支付但未完成。',
  orderConversionTipPaidStatus: '支付已成功完成。',
  orderDeliver: '已发货',
  orderEnd: '已完成',
  orderPaid: '已支付',
  orderReceived: '已送达',
  orderToAnalyze:
    '为了分析不同订单的来源情况，及时调整广告。并且我们的数据比facebook上的数据更加准确',
  orderWaitPay: '待支付',
  ordernum: '订单号',
  more: '更多',
  orderCodesBatchTips: '每行输入一个订单号，或以逗号分隔',
  ordertime: '订单时间',
  originurl: '您的Shopify商店的原始URL',
  originurlexample: '示例：your-store.myshopify.com',
  originurlprefix: 'URL不能包含以下值：www., https://, http://, /, .br',
  package:
    'If the customer refuses to accept the package and requests a refund, The refund shall be borne by Party B',
  partyAProvides:
    '甲方为合作订单提供退款保证服务，费用为1.5%。如果退款原因经核实是客户在收到产品后不满意，退款费用将由甲方承担，乙方不需要承担相关损失。具体使用场景请参考系统协议附件。',
  partyAProvidesconsumers:
    'Party A provides after-sales customer service to Party B. Party B needs to provide Party A with after-sales email account information so that Party A can handle after-sales, refund and other issues raised by consumers.',
  partyProvides:
    'Party A provides Party B with cross-border Internet payment and settlement services, including:',
  password: '密码',
  payBy: '支付方式',
  payment: '支付',
  paymentDateAnswer:
    '您可以在支付订单履行费后申请提款。提款通常会在1-2个工作日内处理。最终到达时间取决于您的银行。',
  paymentDateTitle: '提现到账时间如何',
  paymentDomain: '支付域名',
  paymentRatesTitle: '各国对应的支付以及费率',
  paymentServicesToParty: `Party A provides payment services to Party B, and Party B needs to inform Party A of the store's login information. Party A also provides Party B with relevant transaction information and settlement information query services, and Party B needs to cooperate with Party A to jointly maintain the stability of the payment product account.`,
  paymentSetting: '支付设置',
  paymentTime: '支付时间',
  paymentaffiliations: '支付联盟',
  paymentaffiliationsdesc: '在您的商店中进行金融交易的服务。',
  shopifyCurrencyConfirmBRL:
    '请确认您 Shopify 商店的货币已设置为 BRL。',
  shopifyCurrencyConfirmCLP:
    '请确认您 Shopify 商店的货币已设置为 CLP。',
  shopifyCurrencyConfirmCOP:
    '请确认您 Shopify 商店的货币已设置为 COP。',
  shopifyCurrencyConfirmEUR:
    '请确认您 Shopify 商店的货币已设置为 EUR。',
  shopifyCurrencyConfirmGBP:
    '请确认您 Shopify 商店的货币已设置为 GBP。',
  shopifyCurrencyConfirmMXN:
    '请确认您 Shopify 商店的货币已设置为 MXN。',
  shopifyCurrencyConfirmPEN:
    '请确认您 Shopify 商店的货币已设置为 PEN。',
  shopifyCurrencyConfirmSEK:
    '请确认您 Shopify 商店的货币已设置为 SEK。',
  shopifyDomainUsedByOtherStore:
    '该域名已被其他 Shopify 店铺使用，请将任意未使用的 Shopify 店铺状态更改为「Inactive」。',
  confirmStoreConnectedWiio:
    '请确认您的店铺是否已连接到 Wiio Dropshipping。',
  confirmStoreConnectedUsaDrop:
    '请确认您的店铺是否已连接到 USADrop Dropshipping。',
  paymentbtntext: '去设置',
  paymentdoamin: '支付域',
  paymentlanguage: '支付语言',
  paymentoptions: '支付选项',
  paymentoptionsdesc: '您商店中接受的支付选项。',
  paymenttitle: '配置您商店接受的支付方式。',
  personalInformationVerification: '个人信息验证',
  personalInformationVerificationSubTitle: '信息验证涉及您的手机号码。',
  phone: '手机号',
  pixel: '像素',
  pixelIDisRequired: 'Pixel ID 是必填项',
  pixelTokenisRequired: 'Pixel Token 是必填项',
  pixelexample:
    '示例：一个客户看到您的广告，访问您的网站并进行购买。像素会跟踪这个过程，帮助您了解哪些广告推动了最多的销售。',
  pixelhelp: '分析您的营销活动的表现，查看客户如何与您的广告和商店互动。',
  pixelid: '像素ID',
  pixelname: '像素名称',
  pixeltoken: '像素token',
  platforms: '平台',
  pleaseFillTheRequiredFields: '请填写必填项',
  pleaseInput: '请输入',
  pleaseInputDomain: '请输入域名',
  pleaseSelect: '请选择',
  pleaseSelectDate: '请选择日期',
  pleconfirmPWD: '请确认密码',
  pleinputPWD: '请输入密码',
  popup: '弹窗',
  popupBackground: '弹窗背景图',
  popupConfig: '弹窗配置',
  popupConfigDesc: '弹窗显示效果及弹出规则',
  popupCycle: '弹出周期',
  popupCycleItem: '首单用户，每{input}天弹出',
  preview: '预览',
  previousPage: '上一页',
  priceTerms: 'Price Terms',
  privacypolicy: '隐私政策',
  processingTime: `Party A will fulfill all orders from Party B's store and update the processing time, shipping time, product descriptions in Party B's store, etc. according to Party A's requirements. If there are adjustment items, such as out-of-stock products and similar products, Party B should complete the adjustment/removal within 12 hours.`,
  product: '商品',
  productSpecifications:
    'Wrong product, color, size, other SPU, specifications, refunds are borne by Party A',
  productsImitation:
    'Imitation products_imitation brands, the refund shall be borne by Party B',
  propertyRights:
    'Uploading and selling products that infringe intellectual property rights is prohibited',
  protocolBtnPrefix: '我同意',
  protocolBtnTitle: '付款条款与条件和隐私政策',
  protocolDialog: '用户协议',
  questionsSupport: '如果您有任何疑问，请使用我们提供的支持材料：',
  recommendSize: '推荐尺寸：{input}',
  recoverpassowrd: '找回密码',
  recovertitle: '在下面输入您的电子邮箱地址',
  rectifiedAccording: `For refunds of orders that are not rectified according to Party A's requirements, the refund shall be borne by Party B`,
  redirectLink: '跳转链接',
  refundGuaranteeFees: '2、退款保证费',
  refundGuaranteeTerms: 'Refund Guarantee Terms',
  refundShallBe:
    'If the product is not reviewed and the product is out of stock, the refund shall be borne by Party B',
  refundsAreBorne:
    'Logistics information shows that it has not been delivered/updated for a long time, refunds are borne by Party A',
  refundsAreGiven:
    'The product has been reviewed, the product is out of stock and refunds are given to the customer, refunds are borne by Party A',
  register: '注册',
  registersuccess: '注册成功！',
  registertips:
    '我们将使用您的数据来创建您的访问账户并发送帮助您激活商店的信息。',
  requestNumber: '申请编号',
  requests: '订单请求',
  requestsCancellation:
    'The order has not been shipped and the customer requests cancellation',
  save: '保存',
  saveFields: '填写完字段后，保存您已填写的内容。',
  saveSuccessfully: '保存成功',
  search: '搜索',
  secondarydomains: '次要域名',
  selectCountry: '选择国家',
  selectTimeZone: '选择时区',
  service: '服务',
  serviceemail: '服务邮箱',
  setUpDomain: '按照以下步骤，通过您的提供商设置域名。',
  settings: '设置',
  settlementPeriod:
    'Extend the settlement period or suspend settlement; Party A has the right to terminate the Agreement and not return it to Party B. The unsettled amount and deposit will be settled at a different agreed time after six months.',
  shipped:
    'The order time is less than or equal to 3 days, the order has been shipped, and the customer requests to cancel and refund, and the refund shall be borne by Party B',
  shopify: 'Shopify',
  shopifybtntext: '安装',
  shopifytitle: '在您的Shopify商店中安装透明结账。',
  skipshoppingcart: '跳过购物车',
  specificRates: '3、 具体费率',
  specificUsageScenarios:
    'Refunds generated by other methods will be borne by Party A. For specific usage scenarios, click here t',
  sslCertificate: 'SSL 证书',
  start: '开始',
  startDate: '开始日期',
  startUsing: '使用中',
  startconfig: '在这里开始配置',
  status: '状态',
  step1Content: '前往您的域名提供商网站，查找DNS记录配置部分。',
  step1Title: '步骤 1：访问您的提供商面板',
  step2Content:
    '在提供商中，在DNS记录配置部分，添加以下信息。每个字段填写以下对应信息：',
  step2Title: '步骤 2：访问您的提供商面板',
  step3Content:
    '在正确完成与您的域名提供商的上述条目后，您必须等待一段时间以传播信息。此过程通常需要最多4小时。',
  step3Title: '步骤 3：等待传播',
  storeAccessingUrl: '您的Shopify商店访问链接',
  storeBinding: '商店绑定',
  storeBindingSettings: '店铺设置',
  storeLogo: '商店Logo',
  checkoutLogoSizeTip: '建议上传 230 × 50 px 的 Logo 图片',
  storeLogoLimitTips: '建议尺寸: 230*50，200kb以内',
  orderImage: '店铺订单量 - 最近30天',
  orderRemark: '订单备注',
  orderImageLimitTips: '支持上传多张图片',
  viewExample: '查看示例',
  storename: '商店名称',
  termsofuse: '使用条款',
  theCheckoutPage:
    '在结账页面，设置固定的折扣金额/百分比以吸引客户选择此付款方式。',
  theProductsSold:
    'The products sold on the website include products that are not authorized by the brand or use trademarks that are not authorized by the brand, as well as other brand products; non-brand intellectual property infringement, including but not limited to: movies, videos, songs, games, animation works and their peripheral products, including but not limited to figurines, accessories, and character equipment.',
  theRefundShall:
    'If the customer receives the goods and the delivery time is too long and it does not exceed the store time limit, the refund shall be borne by Party B',
  timezone: '时区',
  tips: '提示',
  toEmbedPaymentMethods: '为了嵌入支付方式',
  toenter: '登录',
  tosave: '保存',
  total: '总计',
  trackingNumber: '跟踪号码',
  transactionSettlement:
    'Party B agrees that Party A will deduct the above fees from Party B’s transaction settlement amount.',
  transferPlatform: '订单转化平台',
  tutorial: '教程引导',
  type: '类型：',
  typeofintegration: '集成类型',
  typepassword: '输入您的密码',
  unauthorized:
    'For unauthorized transactions, the refund shall be borne by Party B',
  unauthorizedTransaction: 'Unauthorized transaction',
  unconvertedOrder: '未转化订单',
  update: '更新',
  urlDisplayed: '客户浏览您的在线商店时显示在 Web 浏览器的网址，是自定义域名',
  usedNormally: 'Cannot be used normally, refunds are borne by Party A',
  value: '值：',
  wantsToCancel: 'The customer buys more and wants to cancel and refund',
  whatisapixel: '什么是像素？',
  whatsAppTemplate: 'WhatsApp模板',
  whichTimeZoneSetTitle: '应该设置哪个时区？',
  withdrawalFeeAnswer: '这取决于你的银行手续费。不同的银行收取不同的费用。',
  withdrawalFeeTitle: '提现有哪些费用？',
  withdrawalMethodAnswer:
    '支付所有订单后，您可以提取现金。支持银行转账和Paypal提款。',
  withdrawalMethodTitle: '提现的方式有哪些？',
  yes: '是',
  feeTerms: 'Fee Terms',
  personalInformationTitle: '我的帐户信息',
  personalInformationSubTitle:
    '帐户信息验证是一个确保您的信息准确和最新的过程。它涉及验证您的电话号码，以确保它是正确和最新的。',
  personalInformationTips:
    '注：\n' +
    '为了确保您的身份信息的真实性，我们需要验证您的手机号码。验证绑定后，姓名和手机号码不能修改。如果您无法收到验证码或需要修改验证码，请联系USAdrop支付客户服务/代理。',
  contactName: '联系人姓名',
  contactPhoneAreaCode: '区号',
  contactPhone: '电话号码',
  getVerificationCode: '获取验证码',
  verificationCode: '验证码',
  pleaseEnter: '请输入{input}',
  pleaseSelect2: '请选择{input}',
  fulfillmentPlatform: '履行平台',
  pleaseEnterCorrect: '请输入正确的{input}',
  sendSuccessfully: '发送成功',
  submitSuccessfully: '提交成功',
  serviceUnavailable: '服务不可用',
  loginExpired: '登录已过期，请重新登录',
  toVerification: '去认证',
  activeCustomerPaymentTips: '个人信息验证尚未完成，因此无法使用支付服务。',
  activeCustomerPaymentTips2: '请点击“个人信息验证”完成个人信息验证。',
  skipCartTips1:
    '此功能有助于提高单订单转化率，但会降低添加到购物车的比率。根据需要启用它。',
  skipCartTips2: `激活后，USAdrop Payment将禁用Shopify的“添加到购物车”功能按钮，仅保留动态结账按钮。客户点击这些按钮将直接指向收银台页面。`,
  skipCartTips3:
    '(如果启用此功能后，结账按钮在产品页面上不可见，请按照教程激活动态结账按钮：',
  complete: '完成',
  completeTips: '我们即将发送审核，请确保已根据需要完成修改！',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  pleaseInputRemark: '请填写备注',
  themeColor: '主题色',
  themeColorTips: '你可以使用这个设置来修改“结算”界面的主题颜色。',
  buttonColor: '结算按钮色',
  buttonColorTips: '你可以使用这个设置来更改“立即购买”按钮的颜色。',
  installment: '分期付款',
  unhandledStores: '未处理的商店',
  pixelTop1: '您已绑定GTM，不可再绑定其他Pixel',
  pixelTop2: '您需要先停用已绑定的pixel，才可以使用GTM',
  pixelTop3: 'GTM和其他pixel无需同时绑定。如有疑问，请联系代理。',
  successVideoTop: '成功案例',
  paypalTop: '请联系我们的客服以启用 PayPal 支付.',
  errorMessage: '服务器出现异常',
  wiioRechargeTitle: '提示',
  wiioRechargeDesc: '您请支付月费以使用该平台。',
  wiilRechargeConfirm: '跳转 USAdrop',
  orderPageDesigner: '下单页设计器',
  export: '导出',
  exporting: '导出中...',
  unknownError: '未知错误',
  downloadSuccess: '下载成功',
  defaultExportNotice: '默认导出最近30天日志，最多可选择30天范围',
  pageStyleConfig: '页面样式配置',
  reset: '重置',
  limitedTimeOffer: '限时特惠，立即下单享受折扣！',
  countdownToEnd: '距离活动结束：',
  configLoadedSuccess: '配置数据加载成功',
  configLoadedUseDefault: '未能加载到配置数据，使用默认值',
  configLoadFailed: '获取配置失败，请检查网络或服务',
  confirmRestore: '确认要恢复配置吗?不可逆',
  warning: '警告',
  confirmReset: '确认重置',
  submitSuccess: '提交成功',
  checkoutConfigSaved: '结账页配置已成功保存并生效!',
  saveConfigFailed: '保存配置失败，请稍后重试。',
  visualSizeConfig: '视觉与尺寸配置',
  width: '宽度',
  height: '高度',
  textAndCountdownConfig: '文本与倒计时配置 (营销文案)',
  textContent: '文本内容',
  enterMarketingCopy: '请输入营销文案',
  fontSize: '字体大小',
  fontColor: '字体颜色',
  fontWeight: '字体粗细',
  selectWeight: '选择粗细',
  countdownSettings: '倒计时设置',
  enableCountdown: '启用倒计时',
  countdownPrefix: '倒计时前缀',
  examplePrefix: '例如：距结束',
  endTime: '结束时间',
  selectEndTime: '选择倒计时结束时间',
  textSpacing: '文本/计时间距',
  realtimePreview: '实时预览',
  eventEnded: '活动已结束',
  rowInfo: '第{index}行信息',
  icon: '图标',
  title: '标题',
  bottomTextConfig: '底部文案配置',
  text: '文案',
  suggestedSize: '建议大小',
  logo: 'logo',
  banner: 'banner',
  safetyInfo: '安全信息',
  securityIcons: '安全图标',
  description: '描述',
  confirmSavePageStyle:
    '您确定要保存当前页面样式配置吗？保存后，支付页会立即生效。',
  getCodeTip: '请先完成店铺域名、API Key 和 Secret Key。',
  getCode: '获取代码',
  token_helper_tip: '通过开发者仪表板凭据自动获取访问令牌。',
  copySuccess: '已复制！',
  paymentDetails: '支付凭证',
  viewPaymentCode: '支付码',
  paymentLink: '支付链接',
  paymentCodeDetails: '支付码',
  barcode: '条形码',
  pixPaymentCode: 'PIX 支付码',
  copyPaymentCode: '复制支付码',
  downloadPaymentImage: '下载图片',
  paymentCodeValidUntil: '有效期至',
  paymentImageUnavailable: '无法生成支付码图片。',
  copyFailed: '复制失败，请手动选择并复制支付码。',
  pleaseFillInClientIdAndSecret:
    '请填写 Client ID (API Key) 和 Secret (API Secret Key)',
  pleaseEnterClientIdAndSecret:
    '请输入 Client ID (API Key) 和 Secret (API Secret Key)',
  pleaseFillInClientIdAndSecretFirst:
    '请先填写 Client ID (API Key) 和 Secret (API Secret Key)',
  pleaseContactAgent: '请联系代理',
  createStoreMexicoUSAdropPaymentsTitle: '从 0 开始构建你的 Shopify 商店',
  couponDisplayConfig: '优惠券展示',
  displayMode: '展示模式',
  couponDisplayExpand: '展开',
  couponDisplayHide: '不显示',
  couponHideModeTipStart: '开启后，优惠券输入框默认隐藏。若你已配置',
  couponHideModeTipEnd:
    '且其状态为启用，当客户进行第二次下单时将自动应用。如果你不希望客户使用优惠码，请将该优惠券状态设置为“禁用”。',
  couponDisplayCollapse: '折叠',
  couponUnselected: '未选中',
  couponNoAvailable: '暂无可用',
  couponNoCode: '无需填写',
  productPrice: '产品',
  productDiscount: '折扣',
  productShipping: '送货',
  free: '免费',
  apply: '应用',
  orderPreviewPriceProduct: '$9999.00',
  orderPreviewPriceDiscount: '-$0.00',
  orderPreviewPriceTotal: '$9999.00',
  shippingCalculation: '开启运费计算',
  shippingCalculationTips: '在下单页根据收货地址计算并校验运费。'
}
